<template lang="pug">
  section.orders
    .box--inner
      ul.home__order-statuses
        li.home__order-status.order-status
          .order-status__wrapper
            span.order-status__title Со статусом "Ждут замер":
            span.order-status__count {{ ordersWait || "-" }}
            span.order-status__action
              a(@click="triggerSelectChange('Ждут замер')").link Показать
        li.home__order-status.order-status
          .order-status__wrapper
            span.order-status__title Со статусом "Договор":
            span.order-status__count {{ ordersContract || "-" }}
            span.order-status__action
              a(@click="triggerSelectChange('Договор')").link Показать
        li.home__order-status.order-status
          .order-status__wrapper
            span.order-status__title Со статусом "В производстве":
            span.order-status__count {{ ordersProduction || "-" }}
            span.order-status__action
              a( @click="triggerSelectChange('В производстве')").link Показать
    hr.box__hr
    .orders__section-header
      h2 График монтажей
      builds-list(
        :builds="builds",
        :orderStatuses="orderStatuses",
        :constructorNames="constructorNames"
      )
    hr.box__hr
    section(ref="ordersList")#order-list
      h2 Заказы
      orders-list(
        ref="orderList"
        :orders="orders",
        :orderStatuses="orderStatuses",
        :constructorNames="constructorNames"
      )
    TutorialModal(ref="tutorial" title="Мои заказы")
      .tut-modal__content   
        p Это ваш центр управления заказами. Он помогает у следить за статусами и этапами заказов.
        h3 График монтажей.
        p Сюда попадают все заказы, для которых вы установили дату монтажа. График позволяет не путаться в заказах и помогает соблюдать сроки монтажей.
        h3 Мои заказы.
        p В списке всех заказов видна информация по каждому — нажмите на любое поле в строке, чтобы открыть подробное описание конкретного заказа.
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store/store';

import OrdersList from '@/components/orders/OrdersList/OrdersList.vue';
import BuildsList from '@/components/orders/BuildsList/BuildsList.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';

export default {
  beforeRouteEnter(to, from, next) {
    const { id: firmId } = store.state.user.profile;

    store.commit('startLoad');

    Promise.all([
      store.dispatch('ordersAssemblyGet', firmId),
      store.dispatch('ordersGet', firmId)
    ]).then(() => {
      store.commit('endLoad');
      next();
    });
  },

  props: {
    status: {
      type: String,
      required: false,
      default: ''
    }
  },

  mounted() {
    if (this.status !== '') {
      this.triggerSelectChange(this.$t('statuses.' + this.status));
    }
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id,

      ordersWait: state => state.orders.stats.measurement,
      ordersContract: state => state.orders.stats.contract,
      ordersProduction: state => state.orders.stats.inproduction,

      orders: state => state.orders.orders,
      builds: state => state.builds.builds,
      orderStatuses: state => state.user.orderStatuses,
      constructorNames: state =>
        state.user.constructors.map(constructor => constructor.name)
    })
  },

  methods: {
    triggerSelectChange(optionValue) {
      this.$refs['orderList'].filterByStatus(optionValue);
      this.$scrollTo(this.$refs.ordersList);
    }
  },

  components: {
    OrdersList,
    BuildsList,
    TutorialModal
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/core';

.home {
  &__order-statuses {
    @extend %ul-reset;
    font-weight: bold;
  }
  &__order-status {
    display: block;
    max-width: 300px;
    margin-bottom: 8px;
  }
}
.order-status {
  &__wrapper {
    display: flex;
    justify-content: space-between;
  }

  &__title {
    flex-shrink: 0;
    max-width: 270px;
    width: 100%;
  }

  &__count {
    margin: 0 16px 0 0;
  }
}

.orders__section-header {
  clear: both;
}

.orders__reset-button {
  @extend %hyperlink;
  display: inline-block;
  margin-bottom: 1em;
  float: right;
  font-size: $small-font-size;
}
</style>
